// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1gR7L","buttons":"RemoveExpirationActionButtons_buttons__1T8mI"};